export default __webpack_public_path__ + "static/media/cellphone.2eec6942.png";